// lib/entitlements.ts
// Canonical entitlement helper - single source of truth for Plus user checks

import { computeIsPaid, type PaidProfileLike } from '@/lib/billing/computeIsPaid';

/**
 * Canonical check used by web feature gates. The implementation mirrors the
 * server's additive entitlement sources and therefore fails closed only when
 * none of them is active.
 */
export function isPlusUser(profile: PaidProfileLike): boolean {
  return computeIsPaid(profile);
}
